import { render, staticRenderFns } from "./BeneficiaryInformation.vue?vue&type=template&id=10ce2540&scoped=true"
import script from "./BeneficiaryInformation.vue?vue&type=script&lang=js"
export * from "./BeneficiaryInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ce2540",
  null
  
)

export default component.exports